import dom from "../../../../common/ts/core/dom";

import {
    FILTERS_BAR_FORM_SELECTOR,
    FILTERS_MODAL_FORM_SELECTOR,
    FILTERS_SERP_SUGGESTION_FORM_SELECTOR
} from "./constants";

export default function filterFormData(formSelectors: string[]) {
    return formSelectors.reduce(
        (acc, formSelector) =>
            ({...acc, ...dom.getFormDataMultiSelection(formSelector)}),
        {}
    )
}

export function getFormDataSubmittingInFilterBar() {
    return filterFormData([FILTERS_MODAL_FORM_SELECTOR, FILTERS_BAR_FORM_SELECTOR, FILTERS_SERP_SUGGESTION_FORM_SELECTOR]);
}


export function getFormDataSubmittingFromFiltersModal() {
    return filterFormData([FILTERS_BAR_FORM_SELECTOR, FILTERS_MODAL_FORM_SELECTOR]);
}
